import React from "react";
// import TabTitle from "../tabTitle/TabTitle";
import ContentComponent from "./components/ContentComponent";
import HeaderComponent from "./components/HeaderComponent";
import './HomeStyles.css'
import classnames from 'classnames';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {HomeContainerProps} from "../../containers/home/HomeContainer";

interface TabTitleProps {
    isTabSelected: boolean,
    title: string,
}

const HomeTitle: React.FC<TabTitleProps> = ({isTabSelected, title}) => {
    return (
        <span className={classnames('baseTitleH', (isTabSelected ? 'openedTitleStyleH' : 'closedTitleStyleH'))}>
            {title}
        </span>
    );
};

const HomeContent = styled.div`
    p {
      text-align: justify;
    }

    @media (min-width: 481px) {
        display: flex;
        flex-direction: column;
        flex: 1
    }

    @media (max-width: 480px) {
        display: flex;
        flex-direction: column;
        flex: 1;
        width: 100%;
        overflow: scroll;
        font-size: 12px;
        line-height: 16px;
        margin-bottom: 10px;
    }
`;

const HomeComponent: React.FC<HomeContainerProps> = ({ isTabSelected }) => {
    const { t } = useTranslation();

    return(
        <div id='contentWrapper' className={(isTabSelected ? 'openWrapper' : 'closeWrapper')}>
            <HomeTitle
                title={ t('home.tabName') }
                isTabSelected={isTabSelected}
            />
            {isTabSelected &&
                <HomeContent id='content'>
                    <HeaderComponent />
                    <ContentComponent />
                </HomeContent>
            }
        </div>
    )
};

export default HomeComponent;
